import React, { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from './auth-context'
import './App.css'
import './Home.css'

function Home() {
  const { user } = useAuth()
  const navigate = useNavigate()
  // Only render marketing page for unauthenticated users
  useEffect(() => {
    if (user) {
      navigate('/dashboard', { replace: true })
    }
  }, [user, navigate])

  if (user) {
    // Optionally show a spinner here if you want
    return null
  }

  return (
    <div className="home-page-wrapper">
      <div className="home-page centered">
        {/* Marketing Landing Page */}
        <section className="hero-section">
          <div className="hero-content">
            <h1 className="hero-title">Create Professional Surveys in Minutes</h1>
            <p className="hero-subtitle">
              Powerful survey platform designed for businesses to collect insights, analyze data,
              and make informed decisions quickly.
            </p>

            <div className="hero-actions">
              <Link to="/login" className="btn btn-primary btn-large">
                Get Started Free
              </Link>
              <Link to="/pricing" className="btn btn-ghost btn-large">
                View Pricing
              </Link>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default Home
